import axios from "axios";

const apiUrl = './assets/data/'

export const fetchData = (domain, cb) => {
  return axios.get(apiUrl + domain)
    .then((res) => {
      return cb({
        success: true, 
        data: res.data,
      })
    })
    .catch(err => {
      alert(err)
      return cb({
        success: false, 
        data: err,
      })
    })
}